import {
  Button, useDataProvider,
  useRecordContext, useRefresh, useShowContext
} from 'react-admin';

const AdvertisementDisableButton = (props) => {
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const { resource } = useShowContext();
  const record = useRecordContext();
  if (!record) { return null; }
  
  return (
    <Button
      {...props}
      disabled={!record?.isEnabled}
      label={record?.isEnabled ? "Desativar anúncio" : "Anúncio desativado"}
      variant={props.isOutlined ? "outlined" : undefined}
      onClick={() => {
        dataProvider.update(resource, { id: record.id, data: { isEnabled: false }, previousData: { ...record } })
          .then(() => {
            refresh();
          })
          .catch(() => console.log("Erro na mensagem"));
      }}
    />
  );
};

export default AdvertisementDisableButton;